import * as React from 'react';

import * as styles from './Utilities.css';

interface IUtilitiesProps {
  children: React.ReactNode;
}

export const Utilities: React.FC<IUtilitiesProps> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
